import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import styles from "./ForgotPasswordScreen.module.scss";

import {
  forgotPasswordSendCode,
  forgotPassword,
} from "../../store/slices/auth/asyncThunks";
import { notifyInfo, notifyError } from "../../utils/notify";
import { isValidEmail } from "../../utils/util";

import Button from "../../components/Button/Button";
import Card from "../../components/Card/Card";
import Input from "../../components/Input/Input";

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState("");
  const [verifyCodeSent, setVerifyCodeSent] = useState(false);

  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validateResetData = useMemo(() => {
    if (
      code.trim().length > 0 &&
      newPassword.trim().length > 0 &&
      confirmPassword.trim().length > 0
    ) {
      return true;
    } else {
      return false;
    }
  }, [code, newPassword, confirmPassword]);

  const validateData = useMemo(() => {
    if (email.trim().length > 0 && isValidEmail(email)) {
      return true;
    } else {
      return false;
    }
  }, [email]);

  const sendCode = () => {
    dispatch(forgotPasswordSendCode({ email })).then((promise) => {
      if (promise.type.includes("fulfilled")) {
        notifyInfo("Code sent successfully");
        setVerifyCodeSent(true);
      } else {
        notifyError(promise.error.message);
      }
    });
  };

  const resetPassword = () => {
    if (newPassword === confirmPassword) {
      dispatch(forgotPassword({ email, newPassword, code })).then((promise) => {
        if (promise.type.includes("fulfilled")) {
          notifyInfo("Password reset successfully");
          navigate("/login");
        } else {
          notifyError(promise.error.message);
        }
      });
    } else {
      notifyError("Passwords doesnt match");
    }
  };

  return (
    <div className={styles.loginScreenContainer}>
      <div className={styles.card}>
        <Card>
          <div className={styles.loginCardContainer}>
            <h1>Forgot password?</h1>

            {verifyCodeSent ? (
              <div>
                <Input
                  placeholder="Verifying code"
                  onChange={(event) => setCode(event)}
                  value={code}
                ></Input>
                <Input
                  placeholder="New password"
                  onChange={(event) => setNewPassword(event)}
                  type="password"
                  value={newPassword}
                ></Input>
                <Input
                  placeholder="Confirm password"
                  onChange={(event) => setConfirmPassword(event)}
                  type="password"
                  value={confirmPassword}
                ></Input>

                <div className={styles.buttonContainer}>
                  <Button
                    aria-label="Reset password"
                    title="Reset Password"
                    disabled={!validateResetData}
                    onClick={resetPassword}
                  />
                </div>
              </div>
            ) : (
              <div>
                <Input
                  placeholder="Email"
                  onChange={(event) => setEmail(event)}
                  id="sendCode"
                  value={email}
                ></Input>
                <div className={styles.buttonContainer}>
                  <Button
                    aria-label="Send Code"
                    title="Send Code"
                    disabled={!validateData}
                    onClick={sendCode}
                  />
                </div>
              </div>
            )}
          </div>
        </Card>
      </div>
      <h3>Powered by Aware Technology</h3>
    </div>
  );
};

export default ForgotPasswordScreen;
